import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2","key":"svg-0"}],["path",{"d":"M8 6h.01","key":"svg-1"}],["path",{"d":"M16 18h.01","key":"svg-2"}],["path",{"d":"M10 9h2.5a1.5 1.5 0 0 1 0 3h-1.5h1.5a1.5 1.5 0 0 1 0 3h-2.5","key":"svg-3"}]]

const IconPlayCard3 = createReactComponent('outline', 'play-card-3', 'PlayCard3', __iconNode);

export default IconPlayCard3;